<template>
  <input
      type="text"
      :id="name"
      class="form-control"
      :class="inputClass"
      :placeholder="label"
      :value="computedValue"
      :disabled="disabled"
      autocomplete="off"
  >
</template>

<script>
import moment from 'moment'

export default {
  props: {
    name: {
      required: false,
      type: String
    },

    label: {
      required: false,
      type: String
    },

    value: {
      required: true
    },

    parameters: {
      required: false,
      type: Object,
      default() {
        return {}
      }
    },

    disabled: {
      required: false,
      type: Boolean,
      default: false
    },

    format: {
      required: false,
      type: String,
      default: 'YYYY-MM-DD'
    },

    originalFormat: {
      required: false,
      type: String,
      default: 'YYYY-MM-DD'
    },

    inputClass: {
      required: false
    }
  },

  mounted() {
    $(this.$el).datetimepicker(this.computedParameters)

    $(this.$el).on('dp.change', event => {
      if (!moment(event.target.value, this.format).isValid()) {
        return this.$emit('input', null)
      }

      this.$emit('input', moment(event.target.value, this.format).format(this.originalFormat))
    })
  },

  computed: {
    computedParameters() {
      return {...this.parameters, format: this.format, keepInvalid: true}
    },

    computedValue() {
      if (!this.value) {
        return null
      }

      return moment(this.value).format(this.format)
    }
  }
}
</script>
